module.exports = __webpack_public_path__ + "img/katarina_outside_18.a1c46450.jpg";